import ClassifyTree from '@/modules/projectA/components/agreement/agreementManage//classifyTree';
import agreementApi from '@/modules/projectA/api/agreement/index';

export const suppliers = {
  components: { ClassifyTree },
  data: () => ({
    classifyVisible: false,
    categoryTreeData: [],
    defaultCheckedKeys: [],
  }),
  methods: {
    /* changSelectKey(keyMap, query) {
      const newArr = query;
      newArr.map((item, index) => {
        const obj = newArr[index];
        for (const key in obj) {
          const newkey = keyMap[key];
          if (newkey) {
            obj[newkey] = obj[key];
          }
          delete obj[key];
        }
      });
      console.log(newArr);
      return newArr;
    },
    // 获取供应商
    async getShieldCompanyNames(row) {
      if (row != '') {
        this.selectLoading = true;
        const params = {
          pageSize: 20,
          pageNum: 1,
          companyName: row,
        };
        const res = await api.querySupplier(params);
        if (res.code == '200') {
          this.selectLoading = false;

          // 映射关系
          const keyMap = {
            companyName: 'name',
            companyId: 'id',
          };

          const arr = this.changSelectKey(keyMap, res.data.records);
          this.listTypeInfo.shieldCompanyNameList = [...arr];
        }
      } else {
        this.listTypeInfo.shieldCompanyNameList = [];
      }
    }, */
    //
    async getQueryShareCategoryTree(params) {
      const result =
        await agreementApi.queryCentralizedCategoryTreeByAgreementId(params);
      if (result.code === '200') {
        console.log(result, 'result');
        this.categoryTreeData = [...result.data.children];
      }
    },
    // 选择所属分类
    focusClassify() {
      if (this.listQuery.categoryIdList?.length) {
        this.defaultCheckedKeys = this.listQuery.categoryIdList;
      }
      this.classifyVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      const filterNode = [];
      val.forEach((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.listQuery.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.listQuery.categoryName = arr.join('、');
      this.classifyVisible = false;
    },

    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },
  },
};

export const goodsAuditMap = {
  data() {
    return {
      tableLabel: [
        {
          label: '商品编号',
          param: 'skuCode',
          align: 'center',
          minWidth: '200',
        },
        {
          label: '商品名称',
          param: 'skuName',
          align: 'center',
          minWidth: '220',
        },
        {
          label: '所属分类',
          param: 'categoryName',
          align: 'center',
          minWidth: '160',
        },
        {
          label: '市场价(元)',
          param: 'price',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '惠享价(元)',
          param: 'sharePrice',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '集采价(元)',
          param: 'agreementPrice',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '协议',
          param: 'agreementName',
          align: 'center',
          minWidth: '180',
        },
        {
          label: '审核状态',
          param: 'orgCount',
          align: 'center',
          minWidth: '100',
          render: (row) => {
            const confirmStatusMap = {
              1: '待审核',
              2: '审核通过',
              3: '待审拒绝',
            };
            return confirmStatusMap[row.confirmStatus];
          },
        },
        {
          label: '审核人',
          param: 'updateName',
          align: 'center',
          minWidth: '100',
        },
        {
          label: '操作时间',
          param: 'updateTime',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'handle',
          width: '120',
          fixed: 'right',
        },
      ],
      filterInfo: {
        fieldList: [
          {
            label: '审核状态',
            type: 'select',
            value: 'confirmStatus',
            list: 'confirmStatusList',
          },
          { label: '商品编号', type: 'input', value: 'skuCode' },
          {
            label: '商品名称',
            type: 'input',
            value: 'skuName',
          },
          {
            label: '分类',
            type: 'dialog',
            value: 'categoryName',
            placeholder: '支持多选',
          },
          {
            label: '协议名称',
            type: 'input',
            value: 'agreementName',
          },
          {
            label: '审核人',
            type: 'input',
            value: 'updateName',
          },
          /* {
            label: '供应商',
            type: 'select',
            value: 'supplierCompanyId',
            list: 'shieldCompanyNameList',
            filterable: true,
            remote: true,
            reserveKeyword: true,
            loading: this.selectLoading,
            clearable: true,
            companyName: true,
            remoteMethod: this.getShieldCompanyNames,
          }, */
          {
            label: '审核时间',
            type: 'date',
            value: 'auditTime',
            dateType: 'datetimerange',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            defaultTime: ['00:00:00', '23:59:59'],
            placeholder: '审核时间',
          },
        ],
        listTypeInfo: {
          confirmStatusList: [
            {
              name: '全部',
              id: '',
            },
            {
              name: '待审核',
              id: 1,
            },
            {
              name: '通过',
              id: 2,
            },
            {
              name: '驳回',
              id: 3,
            },
            {
              name: '已撤回',
              id: 4,
            },
          ],
        },
      },
    };
  },
};
